namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmOAuthProfil extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmOAuthProfilReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmOAuthProfilObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmOAuthProfilObj());
            this.detailObj.createBase({
                contentName: "detailAdmOAuthProfil",
                contentCaption: "jres:33000386",  //RC 33000386 : Profil OAuth
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: true,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmOAuthProfil", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            this.detailObj.consentInfo();
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmOAuthProfilObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmOAuthProfilReadDto> {
        private srv: GContent;
        private povolPrompt: boolean;
        private povolCs: boolean;
        private ixsNathanVytezovac: string;
        private povolAdministraceOcrVytezovac: boolean;
        private permissionNathanVytezovac: boolean;
        private debugOrDevelop: boolean;

        private getSrv(): GContent {
            if (!this.srv)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmOAuthProfil");
            return this.srv;
        }

        create() {
            
        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return (this.data.ixs_oap) ? this.data.ixs_oap.toString() : "";
        }

        saveBase(close: boolean) {
            this.hideAllFlash();
            var form = this.cnt.findForms("{0}form".format(this.options.contentName))
            var novaData: any = {};
            //form.gform("waitForValues").done(() => {
            //    if (form.gform("isValid")) {
            //        return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                        form.findFields().gfield("model", "collect", novaData);
                        if (this.options.newRecord == true) {
                            this.saveData(novaData, close);
                        } else {
                            if (this.importantChange(novaData) == true) {
                                this.cnt.dialogs.confirmDangerous("jres:33000045", "jres:33000515".format((this.data.typ_aut_oauth == 10) ? "jres:33000516" : "")).on("yes", () => { //RC 33000516 : (včetně souhlasu)
                                    this.saveData(novaData, close);
                                });
                            } else {
                                this.saveData(novaData, close);
                            }
                        }
            //        })
            //    }
            //})
        }

        private importantChange(novaData: any): boolean {
            if (this.data.clie_id != novaData["clie_id"])
                return true;
            else if (this.data.tenant_id != novaData["tenant_id"])
                return true;
            else if (this.data.typ_aut_oauth != novaData["typ_auth_oauth"])
                return true;
            return false;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmOAuthProfilSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            var changeImportantData = this.importantChange(data);
            this.getSrv().call("SaveOAuthProfil", { profil: data }).done((output) => { 
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    if (this.options.newRecord == false) {
                        if (changeImportantData == true) {
                            this.cnt.isl.AdmOAuthToken.deleteHromadne({ filters: { ixs_oap: data.ixs_oap } }).getData().done((o) => {

                            })
                        }
                    }
                    Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsoap");
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmOAuthProfil", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmOAuthProfil.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actOAuthProfileDialog*",
                "actUpsertNathanVytezovac",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" },
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            var isExistNathanVytezovac = this.ixsNathanVytezovac == null || this.ixsNathanVytezovac == undefined;
            return {
                actUpsertNathanVytezovac: {
                    icon: "gi-settings",
                    caption: isExistNathanVytezovac ? "jres:33001019" : "jres:33001020", //RC 33001020 : Aktualizovat NATHAN  vytěžovač
                    tooltip: "jres:33001021", //RC 33001021 : Založí/aktualizuje vazbu na Nathan vytěžovač a propojí ji s tímto profilem
                    visible: this.povolAdministraceOcrVytezovac /*&& this.debugOrDevelop*/,
                    enabled: this.permissionNathanVytezovac,
                    run: (ev, ctx) => {
                        return this.upsertNathanVytezovac();
                    }
                },
                actOAuthProfileDialog: {
                    caption: "jres:33000390", //RC 33001052 : Získat adm. souhlas
                    tooltip: "jres:33001053", //RC 33001053 : Získá administrátorský souhlas pro tento OAuth profil
                    icon: "fa-external-link",
                    enabled: this.editMode == false && this.data.typ_aut_oauth == 10 && this.data.aktivita == 100,
                    run: (ev, ctx) => {
                        this.actOAuthProfileDialog()
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.findFields("cl_sec").gfield(this.options.newRecord == true ? "enable" : "disable");
            this.cnt.findFields("csas_api_key").gfield(this.options.newRecord == true ? "enable" : "disable");
            this.cnt.actions.upsertNathanVytezovac?.update({ enabled: this.permissionNathanVytezovac && this.editMode == false })
            this.cnt.actions.actOAuthProfileDialog?.update({ enabled: this.editMode == false && this.data.typ_aut_oauth == 10 && this.data.aktivita == 100 })
        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeField("ixs_oap", {
                flag: this.createFlagNemenne(),
            });
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeSelectField("typ_cloudu", Gordic.Prefabs.Select.admGinctcl(), {
                flag: this.createFlagNemenne(),
                model: "model.typ_cloudu=value.typ_cloudu",
                serverFilters: this.povolCs ? {
                    aktivita: 100
                } : {},
                change: (ev, ctx) => {
                     this.typClouduChange();
                }
            })
            this.MakeSelectField("csas_type", Gordic.Prefabs.Select.ginccst(), {
                model: "model.csas_type=value.csas_type",
                flag: "required"
            })
            this.MakeSelectField("typ_aut_oauth", Gordic.Prefabs.Select.admGinctao(), {
                model: "model.typ_aut_oauth=value.typ_aut_oauth",
                change: (ev, ctx) => {
                    this.typClouduChange();
                    //this.typAuthOAuthChange(ctx.value)
                    //this.urlError();
                    //this.consentInfo();
                    //var o365UrlField = this.cnt.findFields("o365_url");
                    //if (ctx.value) {
                    //    if (!Array.isArray(ctx.value)) {
                    //        switch (ctx.value.typ_aut_oauth) {
                    //            case 30:
                    //                o365UrlField.gfield("option", "validators", [])
                    //                this.HideField("tenant_id");
                    //                this.HideField("clie_id");
                    //                this.HideField("o365_url");
                    //                this.HideField("prompt");
                    //                this.HideField("zpusob_ulozeni_hesla");
                    //                this.HideField("cl_sec");
                    //                this.HideField("password_map");
                    //                this.HideField("update_password");
                    //                break;
                    //            default:
                    //                o365UrlField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                    //                this.ShowField("tenant_id");
                    //                this.ShowField("clie_id");
                    //                this.ShowField("o365_url");
                    //                this.ShowField("prompt");
                    //                this.ShowField("zpusob_ulozeni_hesla");
                    //                this.ShowField("cl_sec");
                    //                if (this.options.newRecord == false)
                    //                    this.ShowField("update_password");
                    //                break;
                    //        }
                    //    }
                    //}

                }
            })
            this.MakeField("tenant_id");
            this.MakeField("clie_id");
            this.MakeField("o365_url", {
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                change: (ev, ctx) => {
                    this.urlError();
                }
            });
            if (this.povolPrompt == true) {
                this.MakeSelectField("prompt", Gordic.Prefabs.Select.admGincoap(), {
                    model: "model.prompt=value.prompt",
                    serverFilters: {
                        prompt: [0, 40]
                    }
                })
            }
            this.MakeBool10Field("update_password", {
                change: (ev, obj) => {
                    this.cnt.findFields("cl_sec").gfield(obj.value == true ? "enable" : "disable");
                    //var field = this.cnt.findFields("cl_sec");
                    //var fieldZpusob = this.cnt.findFields("zpusob_ulozeni_hesla");
                    //var passwordMap = this.cnt.findFields("password_map");
                    //if (obj.value == true) {
                    //    field.gfield("enable")
                    //    fieldZpusob.gfield("enable")
                    //    passwordMap.gfield("enable")
                    //} else {
                    //    field.gfield("disable")
                    //    fieldZpusob.gfield("disable")
                    //    passwordMap.gfield("disable")
                    //}
                }
            });
            this.createPasswordField({
                name: "cl_sec",
                form: this.form,
                popis: "jres:33000387",
                modelFunction: (op, dto, opt) => {
                    var field = this.cnt.findFields("cl_sec");
                    switch (op) {
                        case "apply":
                            field.gfield("setValue", {
                                zpusob_ulozeni: dto["zpusob_ulozeni_hesla"],
                                password: dto["cl_sec"], //RC 33001045 : nenastaveno
                                password_map: dto["password_map"]
                            })
                            break;
                        case "collect":
                            var data = field.gfield("getValue");
                            if (data != null) {
                                dto["zpusob_ulozeni_hesla"] = data["zpusob_ulozeni"]
                                dto["cl_sec"] = data["password"]
                                dto["password_map"] = data["password_map"]
                            }
                            break;
                    }
                }
            })
            this.MakeBool10Field("csas_api_key_update", {
                change: (ev, obj) => {
                    this.cnt.findFields("csas_api_key").gfield(obj.value == true ? "enable" : "disable");
                    //var field = this.cnt.findFields("cl_sec");
                    //var fieldZpusob = this.cnt.findFields("zpusob_ulozeni_hesla");
                    //var passwordMap = this.cnt.findFields("password_map");
                    //if (obj.value == true) {
                    //    field.gfield("enable")
                    //    fieldZpusob.gfield("enable")
                    //    passwordMap.gfield("enable")
                    //} else {
                    //    field.gfield("disable")
                    //    fieldZpusob.gfield("disable")
                    //    passwordMap.gfield("disable")
                    //}
                }
            });
            this.createPasswordField({
                name: "csas_api_key",
                form: this.form,
                popis: "jres:33001046", //RC 33001046 : Api key
                modelFunction: (op, dto, opt) => {
                    var field = this.cnt.findFields("csas_api_key");
                    switch (op) {
                        case "apply":
                            field.gfield("setValue", {
                                zpusob_ulozeni: dto["csas_api_key_zpusob_ulozeni"],
                                password: dto["csas_api_key"], //RC 33001045 : nenastaveno
                                password_map: dto["csas_api_key_map"]
                            })
                            break;
                        case "collect":
                            var data = field.gfield("getValue");
                            if (data != null) {
                                dto["csas_api_key_zpusob_ulozeni"] = data["zpusob_ulozeni"]
                                dto["csas_api_key"] = data["password"]
                                dto["csas_api_key_map"] = data["password_map"]
                            }
                            break;
                    }
                }
            })
            this.MakeSection("");


            //this.form.addRow({ label: "jres:33000846", name: "zpusob_ulozeni_hesla" }).addField("gradio", { //RC 33000846 : Způsob uložení client secret
            //    name: "zpusob_ulozeni_hesla",
            //    disabled: !this.editMode,
            //    itemClass: "w-12",
            //    radios: [
            //        { value: 0, label: "jres:33000632" }, //RC 33000632 : Databáze
            //        { value: 10, label: "jres:33000633" }, //RC 33000633 : Přímé mapování
            //        { value: 20, label: "jres:33000634" } //RC 33000634 : Nepřímé mapování
            //    ],
            //    change: (ev, ctx) => {
            //        this.hesloOpenFields();
            //    }
            //})
            //this.form.addRow("jres:33000387").addField("gstringbox", Gordic.Prefabs.GStringBox.password({ //RC 33000387 : Client secret
            //    obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            //}), {
            //    name: "cl_sec",
            //    disabled: !this.editMode
            //})
            //this.form.addRow({ label: "jres:33000635", name: "password_map_row" }).addField("gstringbox", {
            //    name: "password_map",
            //    disabled: !this.editMode,
            //    flag: "required",
            //    tag: {
            //        text: "jres:33000644", //RC 33000644 : Sem nezadávejte heslo ale pouze informaci, kde je heslo uloženo (odkaz, identifikátor)!
            //        state: "warning"
            //    }
            //})
            this.MakeField("dat_od");
            this.MakeField("dat_do");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private typClouduChange() {
            var typCloudu = this.cnt.findFields("typ_cloudu").gfield("getValue")
            var o365UrlField = this.cnt.findFields("o365_url");
            var typAuthField = this.cnt.findFields("typ_aut_oauth");
            var tenandIdField = this.cnt.findFields("tenant_id");
            var clieIdField = this.cnt.findFields("clie_id");
            var promptField = this.cnt.findFields("prompt");
            var csas_type = this.cnt.findFields("csas_type");
            o365UrlField.gfield("option", "validators", [])
            typAuthField.gfield("option", "validators", [])
            tenandIdField.gfield("option", "validators", [])
            clieIdField.gfield("option", "validators", [])
            promptField.gfield("option", "validators", [])
            csas_type.gfield("option", "validators", [])
            this.HideField("typ_aut_oauth");
            this.HideField("tenant_id");
            this.HideField("clie_id");
            this.HideField("o365_url");
            this.HideField("prompt");
            this.HideField("zpusob_ulozeni_hesla");
            this.HideField("cl_sec");
            this.HideField("csas_api_key");
            this.HideField("password_map");
            this.HideField("update_password");
            this.HideField("csas_api_key_update");
            this.HideField("csas_type");
            if (typCloudu) {
                if (!Array.isArray(typCloudu)) {
                    switch (typCloudu.typ_cloudu) {
                        case 0:
                            // Typ cloudu - Microsoft
                            this.ShowField("typ_aut_oauth");
                            var typ_auth = this.cnt.findFields("typ_aut_oauth").gfield("getValue");
                            if (typ_auth) {
                                if (typ_auth.typ_aut_oauth < 30) { 
                                    o365UrlField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                    typAuthField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                    tenandIdField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                    clieIdField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                    promptField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                                    this.ShowField("tenant_id");
                                    this.ShowField("clie_id");
                                    this.ShowField("o365_url");
                                    this.ShowField("prompt");
                                    this.ShowField("zpusob_ulozeni_hesla");
                                    this.ShowField("cl_sec");
                                    this.urlError();
                                    this.consentInfo();
                                    if (this.options.newRecord == false)
                                        this.ShowField("update_password");
                                    break;
                                }
                            }
                            break;
                        case 30:
                            // Typ cloudu - ČSAS
                            clieIdField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                            o365UrlField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                            csas_type.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
                            this.ShowField("csas_type")
                            this.ShowField("clie_id");
                            this.ShowField("o365_url");
                            this.ShowField("csas_api_key");
                            if (this.options.newRecord == false)
                                this.ShowField("csas_api_key_update");
                            break;
                    }
                }
            }


            //this.cnt.findFields("typ_aut_oauth").gfield("getValue")


            //this.urlError();
            //this.consentInfo();
            
            //if (value) {
            //    if (!Array.isArray(value)) {
            //        switch (value.typ_aut_oauth) {
            //            case 30:
                           
            //                break;
            //            default:
            //                o365UrlField.gfield("option", "validators", [new Gordic.Validators.Required({ stopping: true })])
            //                this.ShowField("tenant_id");
            //                this.ShowField("clie_id");
            //                this.ShowField("o365_url");
            //                this.ShowField("prompt");
            //                this.ShowField("zpusob_ulozeni_hesla");
            //                this.ShowField("cl_sec");
            //                if (this.options.newRecord == false)
            //                    this.ShowField("update_password");
            //                break;
            //        }
            //    }
            //}
        }


        //private hesloOpenFields() {


        //    //var zpusobUlozeniHesla = this.cnt.findFields("zpusob_ulozeni_hesla").gfield("getValue");
        //    //this.cnt.findFields("password_map").gfield("setValidators", []);
        //    //this.HideField("cl_sec")
        //    //this.HideField("password_map")
        //    //if (zpusobUlozeniHesla == 0) {
        //    //    this.ShowField("cl_sec")
        //    //} else if (zpusobUlozeniHesla == 20) {
        //    //    this.ShowField("password_map")
        //    //    this.cnt.findFields("password_map").gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
        //    //}
        //}

        private urlError() {
            this.cnt.findFields("o365_url").gfield("resetErrors", "url-error");
            var url = this.cnt.findFields("o365_url").gfield("getValue");
            var type = this.cnt.findFields("typ_aut_oauth").gfield("getValue");
            if (type != null && type != undefined) {
                if (type.typ_aut_oauth == 10 || type.typ_aut_oauth == 0) {
                    var urlValid = url.endsWith(type.typ_aut_oauth == 10 ? "gin/OAuthConsent.ashx" : "gin/OAuth.ashx")
                    if (urlValid == false) {
                        this.cnt.findFields("o365_url").gfield("setError", {
                            message: "jres:33000961".format(type.typ_aut_oauth == 10 ? "gin/OAuthConsent.ashx" : "gin/OAuth.ashx"), //RC 33000961 : Url pro tento typ profilu OAuth musí končit na '[modul]/{0}'.
                            errorType: "error",
                            stopping: true,
                            group: "url-error"
                        })
                    }
                }
            }
        }

        consentInfo() {
            var typOauthField = this.cnt.findFields("typ_aut_oauth")
            typOauthField.gfield("resetErrors", "consent-info")
            var typOAuth = typOauthField.gfield("getValue");
            if (typOAuth) {
                if (typOAuth.typ_aut_oauth == 10) {
                    typOauthField.gfield("setError", {
                        message: "jres:33000962", //RC 33000962 : Pro tento typ OAuth profilu lze vyjednat administrátorský souhlas pouze v administračních modulech např. ADM05, SSD05...
                        errorType: "info",
                        showOnDisabled: true,
                        stopping: false,
                        group: "consent-info"
                    })
                }
            }
        }

        private upsertNathanVytezovac() {
            let nathanVytezovac: Gordic.AdmIsl.Interface.GAdmOcrVytezovacSaveDto = {
                ixs_aiv: this.ixsNathanVytezovac,
                aiv_poskyt: 10,
                ixs_oap: this.data.ixs_oap,
                aktivita: 100
            }
            return this.cnt.isl.AdmOcrVytezovac.upsert(nathanVytezovac).get().then(() => {
                this.cnt.notification("showToast", {
                    title: "jres:33001022", //RC 33001022 : Nastavení OCR vytěžovače
                    content: "jres:33001023", //RC 33001023 : Nastavení proběhlo úspěšně.
                    state: "success"
                })
                this.reloadDataBase();
            });
        }

        private actOAuthProfileDialog() {
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.OAuthProfileDialog"], {
                ixs_oap: this.data.ixs_oap,
                type: this.data.typ_aut_oauth == 10 ? TypeDialogs.consent : TypeDialogs.login
            }, {
                width: 400,
                height: 300
            })
        }
    }
}